export const APP_TOKEN_KEY = 'TristarLudoLastMileAuth_token';
export const X_AUTH_HEADER = 'x-authorization';

export const VALID_GAME_ID = '219';

export const INSTANT_GAME = 'INSTANT';

// Shared, so every game bounds an unconfigured currency the same way.
export {
  DEFAULT_MIN_BET_AMOUNT,
  DEFAULT_MAX_BET_AMOUNT,
} from '@shared/constants';

export const MAX_BETS_PER_ROUND = 3;
export const ROUND_HISTORY_LIMIT = 10;
export const PRESET_STAKE_COUNT = 7;

// The player's board colour. Cosmetic, and the server never sees it.
export const PAWN_COLOUR_KEY = 'pawnColour';

// Shared with gameAudio, so a typo can't split the toggle from playback.
export const MUSIC_ENABLED_KEY = 'musicEnabled';
export const SOUNDS_ENABLED_KEY = 'soundsEnabled';
